import { useEffect, useRef } from "react";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";

// The only QR generator in the app. Encodes the URL only.
export function IdentityQR({ value, size = 128, fg = "#0B0B0C", bg = "#FFFFFF", className = "", testId = "identity-qr" }) {
  const style = size ? { width: size } : undefined;
  if (!value) {
    return (
      <div data-testid={`${testId}-empty`} className={`mw-qr-empty ${className}`} style={style}>
        Set your card link
      </div>
    );
  }
  return (
    <div data-testid={testId} data-qr-value={value} className={className} style={style}>
      <QRCodeSVG value={value} size={256} fgColor={fg} bgColor={bg} level="M" marginSize={0} title={`QR code for ${value}`} style={{ display: "block", width: "100%", height: "auto" }} />
    </div>
  );
}

// Hidden black-on-white raster of the same QR, for PNG exports (signature, meeting background).
export function IdentityQRPng({ value, size = 512, onReady }) {
  const ref = useRef(null);
  useEffect(() => {
    if (value && ref.current) onReady(ref.current.toDataURL("image/png"), ref.current);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!value) return null;
  return <QRCodeCanvas ref={ref} value={value} size={size} fgColor="#000000" bgColor="#FFFFFF" level="M" marginSize={2} style={{ display: "none" }} />;
}
